import React from 'react';
import { styled } from "styled-components";
import IconX from '../../assets/icon/close.svg';
import { t } from 'ttag';

const Button = styled.button`
  width: 24px;
  height: 24px;
  display: flex;
  z-index: 1;
  border: none;
  padding: 0;
  background: transparent;
  top: 20px;
  float: right
`;

export const CloseButton = ({ onClick, ariaLabel }) => (
  <Button
    onClick={onClick}
    aria-label={ariaLabel || t`close`}
    tabIndex={2}
    className="closeBtn"
  >
    <img src={IconX} alt={t`close`} />
  </Button>
);
